<mat-card class="px-4 w-100 mb-3">
  <mat-card-content class="h-100 d-flex flex-column">
    <mat-card-header class="text-lg-left text-center w-100">
      <mat-card-title class="mt-2 mb-0">
        <span class="pl-4 font-weight-bold">Daily</span>
        <span class="pl-1 light">Totals</span>
      </mat-card-title>
      <mat-card-subtitle class="pl-4 my-0 text-muted" *ngIf="dateInterval.current !== lastWeek" style="font-size: 16px">
        <span role="button" (click)="returnNavigation.emit()">< Return to weekly totals</span>
      </mat-card-subtitle>
    </mat-card-header>
    <div *ngIf="!isEmptyBarChart else noResults" class="d-flex align-items-end h-100">
      <div class="flex-fill w-100 h-100 chart-container" echarts [options]="config"></div>
    </div>
    <span class="chart-footer px-5">"On-Premise" is defined as cars in the yard as of 12 am on that day, and includes resets.</span>
    <ng-template #noResults>
      <div class="h-100 d-flex align-items-center chart-container">
        <span class="w-100 text-center">No Results Found</span>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
